<template>
  <div>
    <el-dialog
      :title="selfDetail.formData.id ? '编辑盘点单' : '新增盘点单'"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfDetail.formData" />
        <div class="flex flex-y-center m-t-10">
          <div class="group-title">盘点明细</div>
          <el-link class="m-b-5 m-l-10" type="primary" size="mini" @click="makeSnapshot">
            <span>从库存生成盘点明细</span>
            <span class="c-red">({{ selfDetail.list.length }})</span>
          </el-link>
          <el-link v-if="selfDetail.formData.id && canRefreshBook" class="m-b-5 m-l-10" type="warning" size="mini" @click="refreshBook"> 重取账面 </el-link>
          <el-link class="m-b-5 m-l-10" type="success" size="mini" @click="itemAdd"> 增行 </el-link>
          <span class="m-l-10 c-gray f-s-12">实盘数留空视为与账面一致；审核时按最新账面重算差异并调整库存</span>
        </div>
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.list"
          :show-footer="!!selfDetail.list.length"
          :max-height="this.$util.getViewHeight() - 460"
          :footer-method="tableFooterMethod"
        >
          <template #default_diff="{ row }">
            <span :class="diffClass(row)">{{ rowDiff(row) }}</span>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link title="清空" @click="itemClear(rowIndex)"> 清空 </el-link>
            <el-link title="删行" @click="itemDelete(rowIndex)"> 删行 </el-link>
          </template>

          <template #edit_material_name="{ row }">
            <el-input v-model="row.material_name" size="mini" clearable />
          </template>
          <template #edit_category="{ row }">
            <el-input v-model="row.category" size="mini" clearable />
          </template>
          <template #edit_spec="{ row }">
            <el-input v-model="row.spec" size="mini" clearable />
          </template>
          <template #edit_unit="{ row }">
            <el-input v-model="row.unit" size="mini" clearable />
          </template>
          <template #edit_batch_no="{ row }">
            <el-input v-model="row.batch_no" size="mini" clearable />
          </template>
          <template #edit_book_qty="{ row }">
            <el-input v-model="row.book_qty" type="number" size="mini" clearable />
          </template>
          <template #edit_actual_qty="{ row }">
            <el-input v-model="row.actual_qty" type="number" size="mini" clearable />
          </template>
          <template #edit_price="{ row }">
            <el-input v-model="row.price" type="number" size="mini" clearable />
          </template>
          <template #edit_remark="{ row }">
            <el-input v-model="row.remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" :loading="saving" :disabled="saving" @click="popupPush">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      selfShow: false,
      saving: false,
      warehouseList: [],
      selfDetail: {
        formData: {
          id: '',
          bill_no: '',
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'),
          warehouse_id: '',
          warehouse_name: '',
          remark: ''
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '360px'
      },
      tableColumn: [
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        { title: '仓位', field: 'location_name', width: 90 },
        { title: '物料名称', field: 'material_name', width: 140, slots: { edit: 'edit_material_name' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '材质', field: 'category', width: 90, slots: { edit: 'edit_category' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '规格(mm)', field: 'spec', width: 120, slots: { edit: 'edit_spec' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '单位', field: 'unit', width: 60, slots: { edit: 'edit_unit' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '批号', field: 'batch_no', width: 110, slots: { edit: 'edit_batch_no' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '账面数', field: 'book_qty', width: 90, slots: { edit: 'edit_book_qty' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '实盘数', field: 'actual_qty', width: 90, slots: { edit: 'edit_actual_qty' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '差异', field: 'diff', width: 80, slots: { default: 'default_diff' } },
        { title: '单价(元)', field: 'price', width: 90, slots: { edit: 'edit_price' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '备注', field: 'remark', width: 110, slots: { edit: 'edit_remark' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '操作', fixed: 'right', slots: { default: 'default_operate' }, width: 90 }
      ]
    }
  },
  computed: {
    canRefreshBook() {
      let st = Number(this.selfDetail.formData.status)
      return st !== 2 && st !== 3
    },
    disabled() {
      // 已审核/已作废不可编辑（列表已控制入口，这里做兜底）
      let st = Number(this.selfDetail.formData.status)
      return st === 2 || st === 3
    },
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    warehouseOptions() {
      return this.warehouseList.map((item) => ({ key: item.warehouse_name, val: item.id }))
    },
    formColumn() {
      return [
        { type: 'text', title: '盘点单号', field: 'bill_no', placeholder: '自动生成', disabled: true },
        { type: 'date', title: '盘点日期', field: 'bill_date', format: 'yyyy-MM-dd', valueFormat: 'yyyy-MM-dd' },
        {
          type: 'select',
          title: '仓库',
          field: 'warehouse_id',
          options: this.warehouseOptions,
          fnChange: () => this.onWarehouseChange()
        },
        { type: 'text', title: '备注', field: 'remark' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getWarehouseList()
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    rowDiff(row) {
      let book = Number(row.book_qty) || 0
      if (row.actual_qty === '' || row.actual_qty === null || row.actual_qty === undefined) {
        return 0
      }
      return this.$XEUtils.subtract(Number(row.actual_qty) || 0, book)
    },
    diffClass(row) {
      let d = this.rowDiff(row)
      if (d > 0) return 'c-green'
      if (d < 0) return 'c-red'
      return ''
    },
    getWarehouseList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200) {
            this.warehouseList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    onWarehouseChange() {
      let wh = this.warehouseList.find((item) => item.id === this.selfDetail.formData.warehouse_id)
      this.selfDetail.formData.warehouse_name = wh ? wh.warehouse_name : ''
    },
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/stockCheck/detail',
        params: { id: this.id }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let fd = res.data.formData || {}
          let keys = ['bill_no', 'bill_date', 'warehouse_name', 'remark']
          keys.forEach((k) => {
            if (fd[k] === null || fd[k] === undefined) fd[k] = ''
          })
          if (fd.bill_date) {
            fd.bill_date =
              typeof fd.bill_date === 'string'
                ? fd.bill_date.substring(0, 10)
                : this.$XEUtils.toDateString(fd.bill_date, 'yyyy-MM-dd')
          }
          this.selfDetail.formData = fd
          this.selfDetail.list = (res.data.list || []).map((item) => {
            item.book_qty = item.book_qty === null || item.book_qty === undefined ? '' : item.book_qty
            // 实盘为空保持空串：视为与账面一致
            item.actual_qty = item.actual_qty === null || item.actual_qty === undefined ? '' : item.actual_qty
            item.price = item.price === null || item.price === undefined ? '' : item.price
            item.batch_no = item.batch_no || ''
            item.location_name = item.location_name || ''
            item.remark = item.remark || ''
            return item
          })
        }
      })
    },
    makeSnapshot() {
      if (!this.selfDetail.formData.warehouse_id) {
        this.$message.warning('请先选择盘点仓库')
        return
      }
      let doFetch = () => {
        this.$api({
          method: 'post',
          url: '/admin/gcvip/inventory/stocklist',
          data: {
            currentPage: 1,
            pageSize: this.$constant.pageMax,
            warehouseId: this.selfDetail.formData.warehouse_id
          }
        })
          .then((res) => {
            if (res.data.state === 'ok') {
              let rows = (res.data.page && res.data.page.list) || []
              this.selfDetail.list = rows.map((item) => ({
                location_id: item.location_id,
                location_name: item.location_name || '',
                material_name: item.material_name || '',
                category: item.category || '',
                spec: item.spec || '',
                unit: item.unit || '',
                batch_no: item.batch_no || '',
                book_qty: item.qty,
                actual_qty: '',
                price: '',
                remark: ''
              }))
              this.$message.success(`已按库存账面生成 ${this.selfDetail.list.length} 行盘点明细`)
            }
          })
          .catch(() => {})
      }
      if (this.selfDetail.list.length) {
        this.$confirm('当前已有明细，重新生成将覆盖原有明细(含已录入实盘数)，确定继续吗?', '提示')
          .then(() => doFetch())
          .catch(() => {})
      } else {
        doFetch()
      }
    },
    refreshBook() {
      if (!this.selfDetail.formData.id) {
        this.$message.warning('请先保存盘点单后再重取账面')
        return
      }
      this.$confirm('将按当前库存主档刷新各行账面数(实盘数保留)，确定继续吗?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/stockCheck/refreshBook',
            params: { id: this.selfDetail.formData.id }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.$message.success(res.data.msg || '账面已刷新')
                this.getDetailData()
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    itemAdd() {
      this.selfDetail.list.push({
        location_id: '',
        location_name: '',
        material_name: '',
        category: '',
        spec: '',
        unit: '',
        batch_no: '',
        book_qty: '',
        actual_qty: '',
        price: '',
        remark: ''
      })
    },
    itemClear(index) {
      let row = this.selfDetail.list[index]
      if (!row) return
      row.material_name = ''
      row.category = ''
      row.spec = ''
      row.unit = ''
      row.batch_no = ''
      row.book_qty = ''
      row.actual_qty = ''
      row.price = ''
      row.remark = ''
    },
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    tableFooterMethod({ columns, data }) {
      let bookTotal = 0
      let actualTotal = 0
      data.forEach((item) => {
        bookTotal = this.$XEUtils.add(bookTotal, Number(item.book_qty) || 0)
        let actual = item.actual_qty === '' || item.actual_qty === null || item.actual_qty === undefined ? Number(item.book_qty) || 0 : Number(item.actual_qty) || 0
        actualTotal = this.$XEUtils.add(actualTotal, actual)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'book_qty') return bookTotal
          if (column.field === 'actual_qty') return actualTotal
          if (column.field === 'diff') return this.$XEUtils.subtract(actualTotal, bookTotal)
        })
      ]
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupPush() {
      if (this.saving) return
      if (!this.selfDetail.formData.warehouse_id) {
        this.$message.warning('请选择盘点仓库')
        return
      }
      if (!this.selfDetail.list.length) {
        this.$message.warning('请先生成或录入盘点明细')
        return
      }
      let data = this.$util.deepCopy(this.selfDetail)
      // 明细继承表头仓库
      data.list.forEach((item) => {
        item.warehouse_id = data.formData.warehouse_id
        item.warehouse_name = data.formData.warehouse_name
      })
      this.saving = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/stockCheck/saveOrUpdate',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch(() => {})
        .then(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .group-title {
    font-size: 13px;
    font-weight: bold;
    color: @colorBlack;
  }
}
</style>
